/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CurrencyCode } from './';
import {
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserCurrencyUpdateRequest
 */
export interface UserCurrencyUpdateRequest {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof UserCurrencyUpdateRequest
     */
    currencyCode: CurrencyCode;
}

/**
 * Check if a given object implements the UserCurrencyUpdateRequest interface.
 */
export function instanceOfUserCurrencyUpdateRequest(value: object): value is UserCurrencyUpdateRequest {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function UserCurrencyUpdateRequestFromJSON(json: any): UserCurrencyUpdateRequest {
    return UserCurrencyUpdateRequestFromJSONTyped(json, false);
}

export function UserCurrencyUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCurrencyUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': CurrencyCodeFromJSON(json['currencyCode']),
    };
}

export function UserCurrencyUpdateRequestToJSON(value?: UserCurrencyUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currencyCode': CurrencyCodeToJSON(value['currencyCode']),
    };
}

